import m from 'mithril'

export default {
  view: vnode => {
    const image1 = require('./image11.jpg')
    const image2 = require('./image23.jpg')

    return (
      <div className={`log-book-page-content-inner log-book-page-template mod-06-page`}>
        <div className={`log-book-text-container ${vnode.attrs.unredacted ? 'is-unredacted' : 'is-redacted'}`}>
          <h3 className="log-book-text mod-h3">Fjenden nærmer sig</h3>
          <p className="log-book-text">
              Eksperter vurderer, at Sovjet har installeret op mod 32 atommissiler på Cuba. Missilerne har en rækkevidde på over 1600 kilometer og kan nemt ramme USA. 
          </p>

          <figure className="log-book-figure">
            <img src={image1} className="log-book-img" />
            <figcaption className="log-book-figcaption">
              CIA-kort over rækkevidde af Cuba-raketterne, 1962.
            </figcaption>
          </figure>

          
          <p className="log-book-text">
              Cubakrisen er kulminationen på en årrække med trusler og fjendtlige handlinger mellem supermagterne. Under Koreakrigen i 1950-53 står USA sammen med Sydkorea over for Nordkorea, der har Sovjet og Kina i ryggen. Tre millioner mennesker dør. Senere slår Sovjet hårdt ned på en opstand i Ungarn. Se tidslinje over Den Kolde Krig bagerst i notesbogen.
          </p>

          <figure className="log-book-figure">
            <img src={image2} className="log-book-img" />
            <figcaption className="log-book-figcaption">
            Tilbage i 1949 underskriver USA, Danmark og 10 andre lande Atlantpagten - NATO er en realitet. NATOs ’musketered’ forpligter landene til at forsvare hinanden, hvis nogen angriber udefra. Som modsvar danner Sovjet Warszawapagten - en tæt militær alliance mellem landene i Østblokken. På billedet er det den amerikanskes præsident Harry S. Truman, der underskriver pagten. Manden med sort butterfly er den danske diplomat Henrik Kauffmann.
            </figcaption>
          </figure>
          
        </div>
      </div>
    )
  }
}
